import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { signedAuthHeaders } from "../../api";
import { coverForCert } from "../../catalogCovers";

const UserCertificates = ({ walletAddress }) => {
    const [certificates, setCertificates] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!walletAddress) {
            setCertificates([]);
            setError(null);
            return;
        }
        let cancelled = false;
        (async () => {
            try {
                const headers = await signedAuthHeaders({ Accept: "application/json" });
                const res = await fetch(`/api/certifications/user/${encodeURIComponent(walletAddress)}`, { headers });
                if (res.status === 401) {
                    if (!cancelled) {
                        setCertificates([]);
                        setError("Sign in with your wallet to load certificates.");
                    }
                    return;
                }
                const data = res.ok ? await res.json() : [];
                if (!cancelled) {
                    setCertificates(Array.isArray(data) ? data : []);
                    setError(null);
                }
            } catch {
                if (!cancelled) {
                    setCertificates([]);
                    setError("Could not load certificates.");
                }
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [walletAddress]);

    if (!walletAddress) return <p>Please connect your wallet.</p>;

    return (
        <div className="user-certificates">
            <h2>Your Certificates</h2>
            {error ? <p>{error}</p> : null}
            {!error && certificates.length === 0 ? (
                <p>No certificates yet.</p>
            ) : (
                <ul className="profile-cert-list">
                    {certificates.map(cert => (
                        <li key={cert.id} className="profile-cert-item">
                            <Link to={`/certificates/${cert.id}`}>
                                <img src={coverForCert(cert)} alt="" />
                                <span>{cert.coursetitle || cert.courseTitle} {cert.issueddate ? `· ${cert.issueddate}` : ""}</span>
                            </Link>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default UserCertificates;